<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import { findConpanyConfig } from '../../../../../../api/Draftgeneration.js';
export default {
    name: '',
    components: {},
    data: function() {
        return {
            headDataI: getdata().headDataI,
            shenbzq: '',
            delCells: [],
            option: [],
            ty:{},
            option1: [
                {
                    value: '227',
                    label: '中国护照'
                },
                {
                    value: '228',
                    label: '城镇退役士兵自谋职业证'
                },
                {
                    value: '100',
                    label: '单位'
                },
                {
                    value: '101',
                    label: '组织机构代码证'
                },
                {
                    value: '199',
                    label: '其他证件'
                },
                {
                    value: '200',
                    label: '个人'
                },
                {
                    value: '201',
                    label: '居民身份证'
                },
                {
                    value: '202',
                    label: '军官证'
                },
                {
                    value: '203',
                    label: '武警警官证'
                },
                {
                    value: '204',
                    label: '士兵证'
                },
                {
                    value: '205',
                    label: '军队离退休干部证'
                },
                {
                    value: '206',
                    label: '残疾人证'
                },
                {
                    value: '207',
                    label: '残疾军人证（1-8级）'
                },
                {
                    value: '208',
                    label: '外国护照'
                },
                {
                    value: '209',
                    label: '港澳同胞回乡证'
                },
                {
                    value: '210',
                    label: '港澳居民来往内地通行证'
                },
                {
                    value: '211',
                    label: '台胞证'
                },
                {
                    value: '212',
                    label: '中华人民共和国往来港澳通行证'
                },
                {
                    value: '213',
                    label: '台湾居民来往大陆通行证'
                },
                {
                    value: '214',
                    label: '大陆居民往来台湾通行证'
                },
                {
                    value: '215',
                    label: '外国人居留证'
                },
                {
                    value: '216',
                    label: '外交官证'
                },
                {
                    value: '217',
                    label: '领事馆证'
                },
                {
                    value: '218',
                    label: '海员证'
                },
                {
                    value: '219',
                    label: '香港身份证'
                },
                {
                    value: '220',
                    label: '台湾身份证'
                },
                {
                    value: '221',
                    label: '澳门身份证'
                },
                {
                    value: '223',
                    label: '高校毕业生自主创业证'
                },
                {
                    value: '222',
                    label: '外国人身份证件'
                },
                {
                    value: '224',
                    label: '就业失业登记证'
                },
                {
                    value: '225',
                    label: '退休证'
                },
                {
                    value: '226',
                    label: '离休证'
                },
                {
                    value: '299',
                    label: '其他个人证件'
                },
                {
                    value: '233',
                    label: '外国人永久居留证'
                },
                {
                    value: '102',
                    label: '营业执照'
                },
                {
                    value: '234',
                    label: '就业创业证'
                },
                {
                    value: '291',
                    label: '医学出生证明'
                }
            ]
        };
    },
    props: {
        params: {
            type: Object,
            default: {}
        },
        showpz: {
            type: Boolean,
            default: false
        },
        tableDataI: {
            type: Array,
            default: []
        },

        headobj: {
            type: Object,
            default: {}
        },
        choosecellCode: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        toseeUpdate: {
            type: Boolean,
            default: false
        }
    },
    created() {
        let params = {
            companyCode: this.params.companyCode,
            shuiBNameCode: this.params.sbbm,
        }
        findConpanyConfig(params).then(res=>{
            if(res.data.code==1){
                this.ty = res.data.data
            }else{
                this.$message.error(res.data.msg)
            }
        })
        this.$nextTick(()=>{
        })
    },
    methods: {
        fun(e,value){
            let time = new Date()
            var year = time.getFullYear() // 获取年
            var month = time.getMonth() + 1 // 获取月
            if(this.ty[0].shenbzq==1||this.ty.shenbzq==0){
                let data = new Date(year,month-1)
                let day = new Date(year,(month-1),0).getDate()
                e.noty_0_x_4.cellVal = year+'-'+(month-1 > 9 ? month-1 : '0' + (month-1))+'-'+'01'
                e.noty_0_x_5.cellVal = year+'-'+(month-1 > 9 ? month-1 : '0' + (month-1))+'-'+ day
            }else if(this.ty[0].shenbzq==2){
                let num = Math.ceil(month/3)
                if(num==1){
                    e.noty_0_x_4.cellVal = year-1+'-09-'+'01'
                    e.noty_0_x_5.cellVal = year-1+'-'+12+'-'+ '31'
                }else{
                    let day = new Date(year,(num-1)*3,0).getDate()
                    e.noty_0_x_4.cellVal = year+'-'+((num-1)*3-2 > 9 ? (num-1)*3-2 : '0'+(num-1)*3-2)+'-'+'01'
                    e.noty_0_x_5.cellVal = year+'-'+(((num-1)*3) > 9 ? (num-1)*3 : '0' + (num-1)*3)+'-'+ day
                }

            }else if(this.ty[0].shenbzq==3){
                if(num==1){
                    e.noty_0_x_4.cellVal = year-1+'-07-'+'01'
                    e.noty_0_x_5.cellVal = year-1+'-12-'+ '31'
                }else if(num==7){
                    e.noty_0_x_4.cellVal = year+'-01-'+'01'
                    e.noty_0_x_5.cellVal = year+'-07-'+ '31'
                }

            }else if(this.ty[0].shenbzq==4){
                let day = new Date(year-1,12,0).getDate()
                e.noty_0_x_4.cellVal = year+'-01-'+'01'
                e.noty_0_x_5.cellVal = year+'-'+12+'-'+ '31'
            }
        },
        selectchange(e) {
            this.fun(e,'shenbzqCzljclf')
            e.noty_0_x_2a.option1 = [
                {
                    value: '302990200',
                    label: '城镇垃圾处理费'
                }
            ];
            e.noty_0_x_14.option1 = [];
            e.noty_0_x_14.cellVal = '';
            e.noty_0_x_2.cellVal = null;
            e.noty_0_x_3.cellVal = null;
        },
        selectchangetwo(e) {
            e.noty_0_x_3a.option2 = [
                {
                    value: '3043313001510002',
                    label: '城镇垃圾处理费[地市100%]'
                }
            ];
        },
        selectchangethree(e) {
            e.taxval.noty_0_x_3a.option2.map(item => {
                if (item.value == e.taxval.noty_0_x_3.cellVal) {
                    e.taxval.noty_0_x_3a.cellVal = item.label;
                }
            });
            this.$emit('forhover', 'tableDataI_I', 'ty_0_x_3a', e.index);
            this.$emit('inputblur', e.taxval.ty_0_x_3a);
        },

        headchange() {
            this.$emit('headchange', this.headobj);
        },
        inputblur(e) {
            this.$emit('inputblur', e);
        },
        forhover(table, colum, index) {
            this.$emit('forhover', table, colum, index);
        },
        zcsclick(e) {
            this.$emit('zcsclick', e);
        },
        fordelete(index) {
            if (this.tableDataI.length < 3) {
                return false;
            }
            if (this.$notemptyandnull(this.tableDataI[index]['noty_0_x_1'].id)) {
                this.delCells.push(JSON.parse(JSON.stringify(this.tableDataI[index])));
            }
            this.tableDataI.splice(index, 1);
            this.$emit('delCellsCode', this.delCells);
        },
        foraddhang() {
            let endobj = this.tableDataI[this.tableDataI.length - 1];
            this.tableDataI.pop();
            this.tableDataI.push({
                noty_0_x_1: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_1',
                    cellType: '0',
                    cellVal: '30299',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_1a: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_1a',
                    cellType: '0',
                    cellVal: '建设行政事业性收费收入',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_2: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_2',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_2a: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_2a',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_3: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_3',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_3a: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_3a',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_4: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_4',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_5: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_5',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_6: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_6',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_7: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_7',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_8: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_8',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_9: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_9',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_10: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_10',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_11: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_11',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_12: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_12',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_13: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_13',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_14: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_14',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_15: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_15',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_16: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_16',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_17: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_17',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_18: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_18',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                },
                noty_0_x_19: {
                    cellCode: 'noty_0_' + (parseFloat(this.tableDataI.length) + 1) + '_19',
                    cellType: '0',
                    cellVal: '',
                    updateDesc: '',
                    map: {}
                }
            });
            this.selectchange(this.tableDataI[this.tableDataI.length-1])

            this.tableDataI.push(endobj);
            this.selectchange(this.tableDataI[this.tableDataI.length - 2]);
        }
    }
};
</script>

<style scoped lang="less">
@import url('./index.less');
@import url('../../SmallScaleVAT/index.less');
</style>
